import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import './Page0Landing.css';

function Page0Landing() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/page2');
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Azure Bicep Maker - VM Deployment</h1>
        <p className="subtitle">Generate validated Bicep templates for Azure VM deployments following Front9/Back9 naming conventions</p>
      </div>

      <div className="page-content">
        <div className="info-section">
          <h2>What You Need</h2>
          <ul className="checklist">
            <li>✓ Azure subscription with Contributor access</li>
            <li>✓ Existing Resource Group</li>
            <li>✓ Existing VNet and Subnet</li>
            <li>✓ VS Code or Azure CLI (authenticated to Azure)</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>What Gets Created</h2>
          <div className="resources-grid">
            <div className="resource-item required">
              <span className="badge">REQUIRED</span>
              <h3>KeyVault</h3>
              <p>Secure password storage for compliance and RDP/SSH access</p>
              <p className="cost">~$0.03/month</p>
            </div>

            <div className="resource-item required">
              <span className="badge">REQUIRED</span>
              <h3>Virtual Machine</h3>
              <p>Windows Server 2022 VM with NIC and OS Disk</p>
              <p className="cost">~$30-140/month (size dependent)</p>
            </div>

            <div className="resource-item optional">
              <span className="badge">OPTIONAL</span>
              <h3>Storage Account</h3>
              <p>Boot diagnostics for troubleshooting</p>
              <p className="cost">~$2-5/month</p>
            </div>

            <div className="resource-item optional">
              <span className="badge">OPTIONAL</span>
              <h3>Log Analytics</h3>
              <p>Centralized monitoring and logging</p>
              <p className="cost">~$10-30/month</p>
            </div>
          </div>
        </div>

        <div className="info-section">
          <h2>How It Works</h2>
          <ol className="steps-list">
            <li>Discover your existing Azure resources (VNet, Subnet, etc.)</li>
            <li>Configure your VM settings (size, environment, region)</li>
            <li>Choose optional features (Storage Account, Log Analytics)</li>
            <li>Add resource tags for organization and cost tracking</li>
            <li>Download validated Bicep templates ready to deploy</li>
          </ol>
        </div>

        <div className="cta-section">
          <button className="btn-primary btn-large" onClick={handleStart}>
            Start Configuration →
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Page0Landing;
